import { render, staticRenderFns } from "./ComponentDropdown.vue?vue&type=template&id=6837937d&scoped=true"
import script from "./ComponentDropdown.vue?vue&type=script&lang=js"
export * from "./ComponentDropdown.vue?vue&type=script&lang=js"
import style0 from "./ComponentDropdown.vue?vue&type=style&index=0&id=6837937d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6837937d",
  null
  
)

export default component.exports